import React, { memo, FC } from 'react'
import TelInput from 'components/TelInput'

type Props = {
  isOpen: boolean
  onSubmit: (phone: string) => void
  onClose: () => void
}

const BookingWorkRecordTelInput: FC<Props> = ({ isOpen, onSubmit, onClose }) => {
  return (
    <TelInput
      isOpen={isOpen}
      title="電話番号を入力"
      isShowPhoneNumberPrefix
      onClickEnter={onSubmit}
      onClickClose={onClose}
    />
  )
}

export default memo(BookingWorkRecordTelInput)
